/**
 * @generated SignedSource<<28dd60d88d0e93fa5e70f3f7458869aa>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type AddUserToGroupModalMutation$variables = {
  connections: ReadonlyArray<string>;
  groupId: string;
  userUuid: string;
};
export type AddUserToGroupModalMutation$data = {
  readonly setUserGroupEnabled: {
    readonly errors: ReadonlyArray<string | null> | null;
    readonly user: {
      readonly email: string;
      readonly id: string;
      readonly organization: {
        readonly id: string;
        readonly name: string;
      } | null;
      readonly uuid: string;
    } | null;
  } | null;
};
export type AddUserToGroupModalMutation = {
  response: AddUserToGroupModalMutation$data;
  variables: AddUserToGroupModalMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "connections"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "groupId"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "userUuid"
},
v3 = [
  {
    "kind": "Literal",
    "name": "enabled",
    "value": true
  },
  {
    "kind": "Variable",
    "name": "groupId",
    "variableName": "groupId"
  },
  {
    "kind": "Variable",
    "name": "userUuid",
    "variableName": "userUuid"
  }
],
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "errors",
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v6 = {
  "alias": null,
  "args": null,
  "concreteType": "User",
  "kind": "LinkedField",
  "name": "user",
  "plural": false,
  "selections": [
    (v5/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "email",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "uuid",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "Organization",
      "kind": "LinkedField",
      "name": "organization",
      "plural": false,
      "selections": [
        (v5/*: any*/),
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "name",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "AddUserToGroupModalMutation",
    "selections": [
      {
        "alias": null,
        "args": (v3/*: any*/),
        "concreteType": "SetUserGroupEnabled",
        "kind": "LinkedField",
        "name": "setUserGroupEnabled",
        "plural": false,
        "selections": [
          (v4/*: any*/),
          (v6/*: any*/)
        ],
        "storageKey": null
      }
    ],
    "type": "Mutations",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v2/*: any*/),
      (v1/*: any*/),
      (v0/*: any*/)
    ],
    "kind": "Operation",
    "name": "AddUserToGroupModalMutation",
    "selections": [
      {
        "alias": null,
        "args": (v3/*: any*/),
        "concreteType": "SetUserGroupEnabled",
        "kind": "LinkedField",
        "name": "setUserGroupEnabled",
        "plural": false,
        "selections": [
          (v4/*: any*/),
          (v6/*: any*/),
          {
            "alias": null,
            "args": null,
            "filters": null,
            "handle": "appendNode",
            "key": "",
            "kind": "LinkedHandle",
            "name": "user",
            "handleArgs": [
              {
                "kind": "Variable",
                "name": "connections",
                "variableName": "connections"
              },
              {
                "kind": "Literal",
                "name": "edgeTypeName",
                "value": "UserEdge"
              }
            ]
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "b0bcdca8b28ccefa571ca321d7396594",
    "id": null,
    "metadata": {},
    "name": "AddUserToGroupModalMutation",
    "operationKind": "mutation",
    "text": "mutation AddUserToGroupModalMutation(\n  $userUuid: String!\n  $groupId: ID!\n) {\n  setUserGroupEnabled(userUuid: $userUuid, groupId: $groupId, enabled: true) {\n    errors\n    user {\n      id\n      email\n      uuid\n      organization {\n        id\n        name\n      }\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "e76eff07b096f2922004b97c3186f2f9";

export default node;
